export const SESSION_MIN_MILLISECONDS = 1000 * 60 * 15;
export const SESSION_IN_PAST_MILLISECONDS = 1000 * 60 * 10;
